import { useQuery, QueryResult } from "@apollo/client";

import { getBUFromLocalStorage } from "helpers/storage";

import { GET_FIELDS_LIST } from "api/MyLivestock/Fields/queries";

import {
  GetFieldsList,
  GetFieldsListVariables,
  GetFieldsList_fields,
} from "api/MyLivestock/Fields/types/GetFieldsList";

interface UseGetFieldsProps extends QueryResult {
  data: GetFieldsList_fields[];
}

export const useGetFields = (): UseGetFieldsProps => {
  const { data, ...rest } = useQuery<GetFieldsList, GetFieldsListVariables>(GET_FIELDS_LIST, {
    variables: {
      businessUnitId: getBUFromLocalStorage(),
    },
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-only",
  });

  const fields = (data?.fields || []) as GetFieldsList_fields[];

  return {
    data: fields,
    ...rest,
  };
};
